import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import ChangePassword from '../../pages/ChangePassword'
import { submitChangePassword } from '../../actions/changePassword'
import { getUser } from '../../selectors/initialization'
import {
  getErrorCode,
  getProcessed,
  getDisabledForm
} from '../../selectors/formCommon'
import { withCenteredBaseWithMenu } from '../../components/Base'

export const mapStateToProps = createSelector(
  [getUser, getErrorCode, getProcessed, getDisabledForm],
  (user, errorCode, processed, disabledForm) => ({
    user,
    errorCode,
    processed,
    disabledForm
  })
)

export const mapDispatchToProps = dispatch => ({
  onSubmit: ({ oldPassword, password }) =>
    dispatch(
      submitChangePassword({
        oldPassword,
        password
      })
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withCenteredBaseWithMenu(ChangePassword))
